import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import DialogHeader from '~components/Dialog/DialogHeader';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

export interface BulkExportSettlementFailureRow {
  message: string;
  settlementId: string;
  settlementLabel: string;
}

interface BulkExportSettlementsFailuresDialogProps {
  failures: BulkExportSettlementFailureRow[];
  isOpen: boolean;
  onClose: () => void;
}

export default function BulkExportSettlementsFailuresDialog({
  failures,
  isOpen,
  onClose,
}: BulkExportSettlementsFailuresDialogProps) {
  return (
    <Dialog isOpen={isOpen} maxWidth="sm" onClose={onClose}>
      <DialogHeader onClose={onClose}>
        {t('approvals.driver_pay.settlements.bulk_export_to_accounting.failures_title')}
      </DialogHeader>

      <DialogContent>
        <Box
          data-test-id="settlement-bulk-export-failures-list"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          {failures.map(({ message, settlementId, settlementLabel }) => (
            <Box key={settlementId}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {settlementLabel}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {message}
              </Typography>
            </Box>
          ))}
        </Box>
      </DialogContent>

      <DialogActions>
        <SmallButton color="secondary" onClick={onClose} variant="outlined">
          {t('actions.close')}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
}
